import React from 'react';
import {
  BrowserRouter as Router,
  Switch,
  Route
} from "react-router-dom";

import { Products } from "../Products";
import { ProductCompare } from "../ProductCompare";
import ProductDetail from "../ProductDetail/ProductDetail";

import './App.scss';
import { Col, Row } from 'react-bootstrap';

export interface AppProps {
  
}

export default function App({}: AppProps) {
  
  return (
    <Router>
      <div className="page v1">
        <div className="container-header">
          <Row>
            <Col>
              <h3 className="mb-0 text-uppercase">Comparateur de fonds</h3>
            </Col>
          </Row>
        </div>
        <Switch>
          {/* <Route path="/compare">
            <ProductCompare />
          </Route> */}
          <Route path="/">
            <Products />
            <ProductCompare />
            <ProductDetail />
          </Route>
        </Switch>
      </div>
    </Router>
  );
}
